export {
    convertToThousands,
    splitByThousands,
    round,
    percentageValue,
    ordinalSuffix
}

function convertToThousands(num, digits = 2, currency = false) {
    if(!num)
        return '-';
        
    const si = [
        { value: 1, symbol: "" },
        { value: 1E3, symbol: "k" },
        { value: 1E6, symbol: "M" },
        { value: 1E9, symbol: "B" },
        { value: 1E12, symbol: "T" },
        { value: 1E15, symbol: "P" },
        { value: 1E18, symbol: "E" }
    ];

    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const abs = Math.abs(num);

    let i = si.length - 1;
    while (i > 0 && abs < si[i].value) i--;

    const formatted =
        (abs / si[i].value)
            .toFixed(digits)
            .replace(rx, "$1") + si[i].symbol;

    return currency
        ? num < 0 ? `-$${formatted}` : `$${formatted}`
        : num < 0 ? `-${formatted}` : formatted;
}

function splitByThousands(num, prefix=''){
    return (num && Number(num)) ? prefix + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-'; 
}

function round(num){
    return Math.round(num);
}

function percentageValue(curr, prev) {
    if(!curr)
        return 0;
    if(!prev)
        return 0;
    
    return Math.round((curr-prev)/prev*100);    
}

function ordinalSuffix(i) {
    i = Number(i);
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}